import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import Repo from "../../Utility/Repo";
import Select from "../../Components/Select";
import { Link } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import { Input } from "design-react-kit";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function ListExecutive(props) {
  const apiToken = useContext(TokenContext);
  const [executiveListTemp, setExecutiveListTemp] = useState();
  const [executiveList, setExecutiveList] = useState([]);
  const [isOpen, toggleModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [removableExecutive, setRemovableExecutive] = useState({});
  const [servizioPredefinito, setServizioPredefinito] = useState([]);
  const [servizi, setServizi] = useState([]);

  // questo da popolare con il cerca esercete
  const [filter, setFilter] = useState({
    name: "",
    pIva: "",
    address: "",
    serviceId: null,
    isEnabled: null,
  });

  //gestione della select ricerca
  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      setFilter({
        ...filter,
        serviceId: selectedOption.value,
      });
    }
    setServizioPredefinito(selectedOption);
  };

  //gestione dell'annulla ricerca
  const handleReset = () => {
    window.location.href = props.subfolder + "/esercenti";
  };

  const handleValidationCheck = (e) => {
    if (e.target.checked === true) {
      setFilter({ ...filter, isEnabled: false });
    } else {
      setFilter({ ...filter, isEnabled: true });
    }
  };

  //filtro cerca
  const sendFilter = () => {
    setLoading(false);

    Repo.searchExecutiveByOperator(apiToken, JSON.stringify(filter))
      .then((response) => {
        setExecutiveListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  //rimozione esercente
  const removeUserAPI = () => {
    Repo.deleteExecutiveIdByOperator(apiToken, removableExecutive.id)
      .then((response) => {
        if (response.status == 204) {
          setRemovableExecutive({});
          window.location.href = props.subfolder + "/esercenti";
        }
      })
      .catch((error) => {
        setRemovableExecutive({});
        console.log(error);
      });
  };

  //set inziale lista attività e dei servizi
  const filterOnLoad = () => {
    setFilter({ ...filter, name: "", pIva: "", address: "", serviceId: null });
    Repo.getExecutiveListByOperator(apiToken)
      .then((response) => {
        setExecutiveList(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });

    Repo.getListaServizi(apiToken)
      .then((response) => {
        setServizi(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  useEffect(() => {
    setLoading(true);
    filterOnLoad();
    setLoading(false);
  }, []);

  return (
    <>
      <div>
        <h1>Lista Esercenti</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Tutti gli esercenti caricati sul sistema. Da qui è possibile cercare
            un esercente o aggiungere uno nuovo.{" "}
          </p>
        </div>

        {/*Inizo cerca*/}

        <div className="row mt-2 text-right">
          <div className="col-lg-12 clearfix">
            <button
              type="button"
              className="btn btn-outline-primary float-right p-2"
              onClick={
                () =>
                  (window.location.href =
                    window.location.pathname + "/nuovo_esercente") //gestione nuovo esercente
              }
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              <span className="align-middle">Nuovo Esercente</span>
            </button>
          </div>
        </div>

        {/*Inizo cerca*/}
        <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
          <p>Sezione di ricerca degli esercenti nella lista</p>
          <div className="row">
            <div className="form-group col-md-4">
              <Input
                id="first_name"
                required
                label="Nome"
                type="text"
                name="first_name"
                value={filter.name}
                onChange={(e) => setFilter({ ...filter, name: e.target.value })}
              />
            </div>
            <div className="form-group col-md-4">
              <Input
                id="p_iva"
                required
                label="P. IVA"
                type="text"
                name="p_iva"
                onChange={(e) => setFilter({ ...filter, pIva: e.target.value })}
              />
            </div>
            <div className="form-group col-md-4">
              <Input
                id="address"
                required
                label="Indirizzo"
                type="text"
                name="address"
                onChange={(e) =>
                  setFilter({ ...filter, address: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="bootstrap-select-wrapper col-md-6 text-left">
              <Select
                aria-label="Scegli una categoria"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                icon={false}
                name="servizio"
                id="servizio"
                onChange={handleSelectChange}
                options={servizi}
                value={servizioPredefinito || ""}
                isClearable
                isSearchable
                placeholder={"Scegli un servizio"}
              />
            </div>
            <div className="form-group col-md-3 text-center">
              <div className="form-check">
                <input
                  id="chkValidUserStatus"
                  type="checkbox"
                  checked={filter.isEnabled === false ? true : false}
                  onChange={handleValidationCheck}
                />
                <label htmlFor="chkValidUserStatus">Da validare</label>
              </div>
            </div>
            <div className="col-md-3 text-right">
              <button
                type="button"
                className="btn btn-outline-secondary m-2"
                onClick={handleReset}
              >
                Annulla
              </button>

              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={sendFilter}
              >
                Cerca
              </button>
            </div>
          </div>
        </div>
        {/*Fine cerca*/}

        <table className="table mt-3">
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">P. IVA </th>
              <th scope="col">Indirizzo</th>
              <th scope="col">Stato</th>
              <th scope="col">Data</th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {executiveList &&
              executiveList.map((x, index) => (
                <tr key={index}>
                  <th scope="row">{x.name}</th>
                  <td>{x.pIva}</td>
                  <td>{x.address}</td>
                  <td className="text-right">
                    <>
                      {x.isEnabled == true ? (
                        <b className="text-success">
                          <span className="icon-wrapper" title="Abilitato">
                            <svg className="icon icon-success">
                              <use href={`${iconSprite}#it-check-circle`}></use>
                            </svg>
                          </span>
                        </b>
                      ) : (
                        <b className="text-success">
                          <span className="icon-wrapper" title="Disabilitato">
                            <svg className="icon icon-danger">
                              <use href={`${iconSprite}#it-error`}></use>
                            </svg>
                          </span>
                        </b>
                      )}
                    </>
                  </td>
                  <td>{x.dataInsert}</td>
                  <td className="text-right" width="150">
                    <Link to={`/esercenti/profilo_esercente?id=${x.id}`}>
                      <button
                        className="btn btn-outline-primary p-1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dettaglio"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </button>
                    </Link>

                    {x.storageFiles && x.storageFiles.length > 0 ? (
                      <button
                        className="btn btn-outline-secondary disabled p-1 ml-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Non è possibile cancellare un utente se ha dati collegati!"
                      >
                        <svg className="icon icon-secondary">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    ) : (
                      <button
                        className="btn btn-outline-danger p-1 ml-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="È possibile eliminare l'esercente solo se non ha caricato file"
                        onClick={() => {
                          toggleModal(!isOpen);
                          setRemovableExecutive({
                            nome: x.name,
                            pIva: x.pIva,
                            id: x.id,
                          });
                        }}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {executiveListTemp && (
          <Pagination
            items={executiveListTemp}
            setCurrentItems={setExecutiveList}
            itemsPerPage={15}
          ></Pagination>
        )}
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={
          "Rimozione esercente: " +
          removableExecutive.nome +
          " " +
          "con P. IVA " +
          removableExecutive.pIva
        }
        body={
          "Confermi di voler rimuovere " +
          removableExecutive.nome +
          " " +
          "con P. IVA " +
          removableExecutive.pIva +
          "?"
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeUserAPI()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListExecutive;
